// extracted by mini-css-extract-plugin
module.exports = {"storeButton":"app-store-button_storeButton__lKkr1"};